import Store from '../Store';

const SupplierStore = new Store('sourcing/suppliers');

export {SupplierStore};